import React from "react";
var StockStar = function (props) {
    return (React.createElement("div", { className: "txt-grey-shade1 stockStar-border-block" },
        React.createElement("span", { className: "RobotoM_14_500" }, props.Rating),
        React.createElement("i", { className: "edel-icon-star-filled" })));
};
export default StockStar;
